import { PROPERTIES_STATUS_FOR_SLUG } from "@/shared/models/const/properties/properties-status.const";
import { I_PropertyDetail } from "@/shared/models/interfaces/entity/property/property.entity";
import { I_propertyDetailResponse } from "@/shared/models/interfaces/response/property/property-detail.interface";
import { get } from "lodash";

export const propertyDetailAdapter = (
  property: I_propertyDetailResponse
) => {
  const obj: any = {};
  get(property, "id") ? (obj.id = property.id) : null;

  get(property, "parent_id") ? (obj.parent_id = property.parent_id) : null;

  get(property, "slug") ? (obj.slug = property.slug + "") : null;

  get(property, "property_title")
    ? (obj.property_title = property.property_title)
    : null;
  get(property, "is_favorite")
    ? (obj.is_favorite = property.is_favorite)
    : null;
  get(property, "price") ? (obj.sale_price = property.price) : null;
  get(property, "alternate_price")
    ? (obj.rent_price = property.alternate_price)
    : null;
  get(property, "currency") ? (obj.currency = property.currency) : null;
  get(property, "business_type")
    ? (obj.business_type = property.business_type)
    : null;
  get(property, "arrangement")
    ? (obj.arrangement = property.arrangement)
    : null;
  get(property, "realstate_type")
    ? (obj.real_estate_type = property.realstate_type)
    : null;
  get(property, "sqm_construction")
    ? (obj.sqm_construction = property.sqm_construction)
    : null;
  get(property, "sqm_land") ? (obj.sqm_land = property.sqm_land) : null;
  get(property, "parking_spots")
    ? (obj.parking_spots = property.parking_spots)
    : null;
  get(property, "bedrooms") ? (obj.bedrooms = property.bedrooms) : null;
  get(property, "bathrooms") ? (obj.bathrooms = property.bathrooms) : null;
  get(property, "city") ? (obj.city = property.city) : null;
  get(property, "city_id") ? (obj.city_id = property.city_id) : null;
  get(property, "sector") ? (obj.sector = property.sector) : null;
  get(property, "sector_id") ? (obj.sector_id = property.sector_id) : null;
  get(property, "maintenance_fee")
    ? (obj.maintenance_fee = property.maintenance_fee)
    : null;
  get(property, "is_collection")
    ? (obj.is_collection = property.is_collection)
    : null;
  get(property, "status")
    ? (obj.status = PROPERTIES_STATUS_FOR_SLUG[property.status])
    : null;

  get(property, "visit_status")
    ? (obj.visit_status = property.visit_status)
    : null;
  get(property, "floor_level")
    ? (obj.floor_level = property.floor_level)
    : null;
  get(property, "floors_total")
    ? (obj.floors_total = property.floors_total)
    : null;
  get(property, "pumps") ? (obj.pumps = property.pumps) : null;
  get(property, "condition_status")
    ? (obj.condition_status = property.condition_status)
    : null;
  get(property, "main_picture")
    ? (obj.main_picture = property.main_picture)
    : null;
  get(property, "project") ? (obj.project = property.project) : null;
  get(property, "agency") ? (obj.agency = property.agency) : null;
  get(property, "agents") ? (obj.agents = property.agents) : [];

  // TODO: improve this
  obj.improvements = {
    location: null,
    use: null
  };

  if (property.improvements.length > 0) {
    obj.improvements.location = property.improvements
      .filter(x => x.name == "Ubicaci&oacute;n")
      .map(x => x.value)
      .join(", ");

    obj.improvements.use = property.improvements
      .filter(x => x.name == "Uso")
      .map(x => x.value)
      .join(", ");
  }

  return obj as I_PropertyDetail;
};
